import gql from "graphql-tag";
import { CUSTOMER_APPLICATION_FIELDS } from "./fragments";

export const updateCustomerApplicationMutation = gql`
  mutation updateCustomerApplication(
    $id: ID!
    $companyName: String
    $customer: CustomerInput
    $dealer: DealerInput
    $comment: String
    $status: CustomerApplicationStatus
    $regionId: ID
    $managerId: ID
    $processingManagerId: ID
    $customerId: ID
  ) {
    updateCustomerApplication(
      id: $id
      comment: $comment
      status: $status
      companyName: $companyName
      customer: $customer
      dealer: $dealer
      regionId: $regionId
      managerId: $managerId
      processingManagerId: $processingManagerId
      customerId: $customerId
    ) {
      id
    }
  }
`;

export const sendCustomerApplicationToOneCMutation = gql`
  mutation sendCustomerApplicationToOneC(
    $id: ID!
    $companyName: String!
    $companyCode: String
    $regionId: ID!
    $managerId: ID!
    $processingManagerId: ID!
    $taxNumber: String
    $firstName: String
    $lastName: String
    $phone: String
    $email: String
  ) {
    sendCustomerApplicationToOneC(
      id: $id
      companyName: $companyName
      companyCode: $companyCode
      regionId: $regionId
      managerId: $managerId
      processingManagerId: $processingManagerId
      taxNumber: $taxNumber
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      email: $email
    ) {
      ...CustomerApplicationFields
    }
  }
  ${CUSTOMER_APPLICATION_FIELDS}
`;

export const syncCustomerApplicationWithOneCMutation = gql`
  mutation syncCustomerApplicationWithOneC(
    $id: ID!
    $companyName: String
    $taxNumber: String
    $companyCode: String
    $firstName: String
    $lastName: String
    $phone: String
    $email: String
  ) {
    syncCustomerApplicationWithOneC(
      id: $id
      companyName: $companyName
      taxNumber: $taxNumber
      companyCode: $companyCode
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      email: $email
    ) {
      ...CustomerApplicationFields
    }
  }
  ${CUSTOMER_APPLICATION_FIELDS}
`;

export const changeCustomerApplicationRegionMutation = gql`
  mutation changeCustomerApplicationRegion($id: ID!, $regionId: ID!) {
    changeCustomerApplicationRegion(id: $id, regionId: $regionId) {
      id
    }
  }
`;

export const changeCustomerApplicationManagerMutation = gql`
  mutation changeCustomerApplicationManager($id: ID!, $managerId: ID!) {
    changeCustomerApplicationManager(id: $id, managerId: $managerId) {
      id
    }
  }
`;

export const recordCustomerApplicationOpenedMutation = gql`
  mutation recordCustomerApplicationOpened($id: ID!) {
    recordCustomerApplicationOpened(id: $id) {
      id
    }
  }
`;

export const addCustomerApplicationCommentMutation = gql`
  mutation addCustomerApplicationComment($id: ID!, $body: String!) {
    addCustomerApplicationComment(id: $id, body: $body) {
      id
      body
      statusAtEvent
      userFullName
      userEmail
      createdAt
    }
  }
`;
